import { $axios } from "@/utils/http.js";
import prefix from "../base.js";

export default {
  // 授权初始化
  initAuth(data) {
    return $axios(`${prefix.config}/init`, data, "GET");
  },
  initActivity(data) {
    return $axios(`${prefix.config}/get_config`, data, "GET");
  }
};
